export default {
  LOADING: 'MARKETS_VIEW_LOADING',
  LOADED: 'MARKETS_VIEW_LOADED',
  LOADING_STATES: 'MARKETS_VIEW_LOADING_STATES',
  LOADED_STATES: 'MARKETS_VIEW_LOADED_STATES',
};
